import React from "react";

function Deception() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 152 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8598 129.253L65.8749 150.746L8.09497 73.9162L12.8598 129.253Z"
        fill="#4F5A9E"
      />
      <path
        d="M53.6688 57.5789L21.9269 48.8416L21.2021 48.6421L21.2983 49.3877L22.1643 56.0949L22.2064 56.4211L22.5226 56.5116L52.3533 65.0471C52.3545 65.0474 52.3556 65.0478 52.3568 65.0481C55.3184 65.9417 57.9085 67.3796 60.1844 69.3153C60.1856 69.3163 60.1867 69.3172 60.1878 69.3182L75.5056 82.8297L75.8267 83.1129L76.156 82.8392L91.3184 70.2362L91.3263 70.2296L91.334 70.2227C94.2116 67.623 97.1701 65.946 100.319 65.2074L100.325 65.2061L130.865 57.684L131.203 57.6007L131.242 57.2547L132.002 50.5476L132.081 49.8417L131.39 50.0047L98.4303 57.775L98.8878 52.0561L132.983 43.3535L133.309 43.2701L133.355 42.9361L134.221 36.5343L134.319 35.8094L133.608 35.9813L100.283 44.0358L101.893 34.3744L138.95 24.0927L139.106 24.0492L139.208 23.9218L150.238 10.03L142.508 63.0941L74.8155 150.176L8.30253 61.4256L1.71337 9.06596L13.3927 23.3692L13.4919 23.4907L13.6428 23.5338L50.5279 34.0628L51.7436 43.6108L19.0032 34.5633L18.2696 34.3606L18.3749 35.1145L19.2408 41.3139L19.2859 41.6364L19.5991 41.7256L52.6488 51.1392L53.6688 57.5789ZM93.4283 105.45L93.7384 106.038L94.2173 105.577L127.574 73.4624L127.092 72.6208L83.2844 84.9175L82.6886 85.0848L82.9773 85.6321L93.4283 105.45ZM23.7246 71.202L23.2284 72.0352L56.857 105.572L57.3422 106.056L57.655 105.446L68.1059 85.0702L68.3804 84.535L67.8041 84.3629L23.7246 71.202Z"
        stroke="#4F5A9E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.029 130.37L142.714 74.7804L84.6108 150.492L137.029 130.37Z"
        fill="#4F5A9E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.2998 61.3661L75.6759 73.6628L88.5102 62.1792L99.2311 1.81311L84.6114 26.4066H68.5277L53.041 1L62.2998 61.3661ZM83.7435 36.5183L76.271 58.5713L68.5277 36.5183H83.7435Z"
        fill="#4F5A9E"
      />
      <path
        d="M137.029 130.37L84.6108 150.492L142.714 74.7813L137.029 130.37ZM83.7438 36.5183H68.527L76.2704 58.5713L83.7438 36.5183ZM62.3001 61.3661L53.0414 1L68.528 26.4066H84.6117L99.2315 1.81311L88.5106 62.1792L75.6762 73.6628L62.3001 61.3661ZM23.5815 71.6811L57.2101 105.218L67.661 84.842L23.5815 71.6811ZM65.8747 150.746L8.09484 73.9162L12.8597 129.253L65.8747 150.746ZM83.4196 85.3998L127.227 73.1031L93.8705 105.217L83.4196 85.3998ZM138.816 23.6108L101.452 33.9779L99.6654 44.6994L133.725 36.4673L132.859 42.869L98.4179 51.66L97.8771 58.4191L131.505 50.4914L130.746 57.1985L100.205 64.7206C96.9558 65.4826 93.9239 67.2091 90.9988 69.8516L75.8364 82.4547L60.5118 68.9374C58.1828 66.9557 55.5295 65.4826 52.4976 64.5684L22.6602 56.0308L21.7942 49.3237L54.284 58.2669L53.0927 50.7457L19.736 41.2447L18.8701 35.0453L52.3345 44.2929L50.9822 33.6725L13.78 23.053L1 7.40176L7.82298 61.6195L74.8083 151L142.984 63.2967L150.998 8.26591L138.816 23.6108Z"
        stroke="#4F5A9E"
        strokeWidth="1.5204"
        strokeMiterlimit="2.6131"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Deception;
